module.exports = __webpack_public_path__ + "static/schodisko-4c28887fec8c8a6614c37f7efdd26afc.jpg";